import { useTranslate } from '@festina-life/ui/hooks'

import { TransferButton } from '../../components/transferButton/TransferButton'
import { useTemplateContext } from '../../context/templateContext'
import { useTemplateIsLibrary } from '../../hooks/useTemplateIsLibrary'
import { useTransferableVersionsInBlock } from '../../hooks/useTransferableVersionsInBlock'
import { useOperationsContext } from '../../workspace/operationsContext'

/** Transfers every version of the template in scope to an ancestor block. */
export const TemplateTransferButton = () => {
  const translate = useTranslate()
  const checkIsLibrary = useTemplateIsLibrary()
  const { templateVersion } = useTemplateContext()
  const { templateOperations } = useOperationsContext()

  const templateId = templateVersion?.versionInfo.identifier ?? ''

  const transferableOperations = useTransferableVersionsInBlock({
    operationsByBlock: templateOperations,
    itemId: templateId,
  })

  return (
    <TransferButton
      item={{
        itemId: templateId,
        type: checkIsLibrary(templateId) ? 'library' : 'template',
        operationName: templateId,
        versionCount: transferableOperations.length,
        isTransferable: !!transferableOperations.length,
      }}
      transfer={{
        label: translate('templateViewer.topBar.actions.transfer'),
        onConfirm: ({ transfer }) =>
          transfer({
            shouldInvalidateCacheAfterTransfer: true,
            operationName: templateId,
            operations: transferableOperations,
          }),
      }}
    />
  )
}
